import { boolean } from '@storybook/addon-knobs';
import {
  SHIPMENT_EXECUTION_ENABLE_LOADING,
  SHIPMENT_EXECUTION_DISABLE_LOADING,
  SHIPMENT_EXECUTION_SET_FILTER,
  SHIPMENT_EXECUTION_APPLY_FILTER,
  SHIPMENT_EXECUTION_PAGINATION,
  SHIPMENT_EXECUTION_RESET_FILTER,
  SHIPMENT_EXECUTION_RESET_MORE_FILTER,
  SHIPMENT_EXECUTION_RESET_PAGINATION,
  SHIPMENT_EXECUTION_SET_PREV_PAGINATION,
  SHIPMENT_EXECUTION_UPDATE_DATA,
  SHIPMENT_EXECUTION_CANCEL_FILTER,
  SHIPMENT_EXECUTION_FETCH_CONTAINERS_DATA,
  SHIPMENT_CONTAINER_FETCHING_DATA,
  SHIPMENT_EXECUTION_MILESTONE_COUNT,
  SHIPMENT_EXECUTION_TOGGLE_WATCH,
  SHIPMENT_EXECUTION_SET_SHIPMENT_INSTRUCTIONS,
  SHIPMENT_EXECUTION_SET_SI_PENDING_COUNT,
  SHIPMENT_EXECUTION_SET_SI_DETAILS,
  SHIPMENT_EXECUTION_SET_SI_LOADING,
  SHIPMENT_EXECUTION_IS_SI_PENDING_COUNT_LOADING,
  SHIPMENT_EXECUTION_SET_VGM_REQUESTS,
  SHIPMENT_EXECUTION_SET_VGM_DETAILS,
  SHIPMENT_EXECUTION_SET_VESSEL_MASTER,
  SHIPMENT_EXECUTION_SET_FORM13_REQUESTS,
  SHIPMENT_EXECUTION_SET_FORM13_DETAILS,
  SHIPMENT_EXECUTION_DROPDOWN_MASTERDATA,
  SHIPMENT_EXECUTION_DISABLE_LOAD_TRACKING,
  SHIPMENT_EXECUTION_ENABLE_LOAD_TRACKING,
  SHIPMENT_EXECUTION_UPDATE_CARD_AT_INDEX,
  SHIPMENT_EXECUTION_SET_SELECTED_SHIPMENTS,
} from 'src/actions/constants';
import GetExecutionData from 'src/dto/response/getExecution';

const defaultState = {
  selectedFilters: {
    polList: [],
    podList: [],
    ffIdList: [],
    modeList: [],
    typeList: [],
    chaIdList: [],
    transporterIdList: [],
    userList:[],
    teamList:[],
    myTaskList: [],
    plantIdList: [],
    incotermList: [],
    cargoTypeList: [],
    customerIdList: [],
    shipmentIdList: [],
    carrierCodeList: [],
    companyCodeList: [],
    dateRange: undefined,
    sortBy: 'updated_at',
    bookingNumberList: [],
    descendingOrder: true,
    searchType: 'SHIPMENT',
    siInttraStatusList: [],
    dateFilter: 'createdAt',
    dateRangeFilter: undefined,
    clientReferenceNumberList: [],
    myTaskStatusFilterList: undefined,
    myTaskNameFilterList: undefined,
    hideDeleted: true,
    supplierIdList: []
  },
  appliedFilters: {
    sortBy: 'updated_at',
    descendingOrder: true,
    polList: [],
    podList: [],
    typeList: [],
    ffIdList: [],
    chaIdList: [],
    transporterIdList: [],
    userList:[],
    teamList:[],
    customerIdList: [],
    shipmentIdList: [],
    carrierCodeList: undefined,
    searchType: 'SHIPMENT',
    clientReferenceNumberList: [],
    bookingNumberList: [],
    dateFilter: 'createdAt',
    dateRange: undefined,
    dateRangeFilter: undefined,
    hasTracking: undefined,
    plantIdList: [],
    companyCodeList: [],
    incotermList: [],
    modeList: [],
    myTaskList: [],
    siInttraStatusList: [],
    myTaskStatusFilterList: undefined,
    myTaskNameFilterList: undefined,
    hideDeleted: true,
    supplierIdList: []
  },
  selectedMoreFilters: {
    polList: [],
    podList: [],
    ffIdList: [],
    modeList: [],
    chaIdList: [],
    transporterIdList: [],
    userList:[],
    teamList:[],
    plantIdList: [],
    incotermList: [],
    customerIdList: [],
    carrierCodeList: [],
    companyCodeList: [],
    productKeyList: [],
    poNumberList: [],
    dateRange: undefined,
    hasTracking: undefined,
    siInttraStatusList: [],
    dateFilter: 'createdAt',
    dateRangeFilter: undefined,
    myTaskStatusFilterList: undefined,
    myTaskNameFilterList: undefined,
    supplierIdList: [],
  },
  appliedMoreFilters: {
    polList: [],
    podList: [],
    ffIdList: [],
    modeList: [],
    chaIdList: [],
    transporterIdList: [],
    userList:[],
    teamList:[],
    plantIdList: [],
    incotermList: [],
    cargoTypeList: [],
    customerIdList: [],
    companyCodeList: [],
    carrierCodeList: [],
    productKeyList: [],
    poNumberList: [],
    dateRange: undefined,
    hasTracking: undefined,
    siInttraStatusList: [],
    dateFilter: 'createdAt',
    dateRangeFilter: undefined,
    myTaskStatusFilterList: undefined,
    myTaskNameFilterList: undefined,
    supplierIdList: [],
  },
  pagination: {
    currentPageNumber: 1,
    resultPerPage: 10,
    nextOrPrev: 'first',
  },
  prevPagination: {
    currentPageNumber: 1,
    resultPerPage: 10,
    nextOrPrev: 'first',
  },
  containerData: [],
  shipmentData: [] as GetExecutionData[],
  updateTaskSummary: false,
  selectedShipments: {},
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case SHIPMENT_EXECUTION_ENABLE_LOAD_TRACKING: {
      return {
        ...state,
        loadTracking: true,
      };
    }
    case SHIPMENT_EXECUTION_DISABLE_LOAD_TRACKING: {
      return {
        ...state,
        loadTracking: false,
      };
    }
    case SHIPMENT_EXECUTION_ENABLE_LOADING: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case SHIPMENT_EXECUTION_DISABLE_LOADING: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case SHIPMENT_EXECUTION_SET_FILTER: {
      return {
        ...state,
        selectedFilters: {
          ...state.selectedFilters,
          ...action.data,
        },
      };
    }

    case SHIPMENT_EXECUTION_CANCEL_FILTER: {
      return {
        ...state,
        selectedFilters: {
          ...state.appliedFilters,
        },
      };
    }

    case SHIPMENT_EXECUTION_APPLY_FILTER: {
      return {
        ...state,
        appliedFilters: {
          ...state.appliedFilters,
          ...state.selectedFilters,
        },
      };

    }

    case SHIPMENT_EXECUTION_PAGINATION: {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.data,
        },
      };
    }

    case SHIPMENT_EXECUTION_RESET_FILTER: {
      return {
        ...state,
        appliedFilters: defaultState.appliedFilters,
        selectedFilters: defaultState.selectedFilters,
      };
    }

    case SHIPMENT_EXECUTION_RESET_MORE_FILTER: {
      return {
        ...state,
        appliedFilters: {
          ...state.appliedFilters,
          ...defaultState.appliedMoreFilters,
        },
        selectedFilters: {
          ...state.selectedFilters,
          ...defaultState.selectedMoreFilters,
        }
      };
    }

    case SHIPMENT_EXECUTION_RESET_PAGINATION: {
      return {
        ...state,
        pagination: {
          ...defaultState.pagination,
          resultPerPage: state.pagination.resultPerPage,
        },
      };
    }

    case SHIPMENT_EXECUTION_SET_PREV_PAGINATION: {
      return {
        ...state,
        pagination: state.prevPagination,
      };
    }

    case SHIPMENT_EXECUTION_FETCH_CONTAINERS_DATA: {
      return {
        ...state,
        isLoading: false,
        containerData: action.data,
      };
    }

    case SHIPMENT_CONTAINER_FETCHING_DATA: {
      return {
        ...state,
        containerData: action.data,
      };
    }

    case SHIPMENT_EXECUTION_UPDATE_DATA: {
      return {
        ...state,
        shipmentData: action.data ? action.data.data : [],
        prevPagination: {
          ...state.pagination,
        },
        pagination: {
          ...state.pagination,
          currentPageNumber: action.data && action.data.currentPageNumber,
          lastSortedColumnValueNext: action.data && action.data.lastSortedColumnValueNext,
          lastSortedColumnValuePrev: action.data && action.data.lastSortedColumnValuePrev,
          lastItemIdNext: action.data && action.data.lastItemIdNext,
          lastItemIdPrev: action.data && action.data.lastItemIdPrev,
          isNextPresent: action.data && action.data.isNextPresent,
          nextOrPrev: action.data && action.data.nextOrPrev,
        },
      };
    }

    case SHIPMENT_EXECUTION_SET_SHIPMENT_INSTRUCTIONS: {
      return {
        ...state,
        shippingInstructions: action.data,
        fetchAllSIError: action.fetchAllError,
      }
    }

    case SHIPMENT_EXECUTION_SET_SI_LOADING: {
      return {
        ...state,
        isFetchingShippingData: action.data,
      }
    }

    case SHIPMENT_EXECUTION_SET_SI_PENDING_COUNT: {
      return {
        ...state,
        siPendingCount: action.data,
      }
    }

    case SHIPMENT_EXECUTION_SET_SI_DETAILS: {
      return {
        ...state,
        siRequestData: action.data,
        siRequestError: action.error,
        siRequestId: action.requestId,
        seDocumentType: action.seDocumentType,
      }
    }

    case SHIPMENT_EXECUTION_SET_VGM_DETAILS: {
      return {
        ...state,
        vgmRequestData: action.data,
        vgmRequestError: action.error,
        vgmRequestId: action.requestId,
        seDocumentType: action.seDocumentType,
      }
    }

    case SHIPMENT_EXECUTION_SET_VGM_REQUESTS: {
      return {
        ...state,
        vgmRequests: action.data,
        fetchAllVGMError: action.fetchAllError,
      }
    }

    case SHIPMENT_EXECUTION_MILESTONE_COUNT: {
      return {
        ...state,
        milestoneCount: action.data,
      };
    }

    case SHIPMENT_EXECUTION_TOGGLE_WATCH: {
      const shipmentData = state.shipmentData;
      shipmentData[action.data.index] = Object.assign(
        shipmentData[action.data.index], {
        isWatching: action.data.isWatching,
        watcherList: action.data.watcherList,
      });

      return {
        ...state,
        shipmentData: [
          ...shipmentData,
        ]
      }
    }

    case SHIPMENT_EXECUTION_IS_SI_PENDING_COUNT_LOADING: {
      return {
        ...state,
        isFetchingContainerCount: action.isFetchingContainerCount,
      }
    }

    case SHIPMENT_EXECUTION_SET_VESSEL_MASTER: {
      return {
        ...state,
        vesselMaster: action.data,
      }
    }

    case SHIPMENT_EXECUTION_SET_FORM13_REQUESTS: {
      return {
        ...state,
        form13Requests: action.data,
        fetchAllform13Error: action.fetchAllError,
      }
    }

    case SHIPMENT_EXECUTION_SET_FORM13_DETAILS: {
      return {
        ...state,
        form13RequestData: action.data,
        form13RequestError: action.error,
        formRequestId: action.requestId,
        seDocumentType: action.seDocumentType,
      }
    }

    case SHIPMENT_EXECUTION_DROPDOWN_MASTERDATA: {
      return {
        ...state,
        dropdownMaster: action.data,
      }
    }

    case SHIPMENT_EXECUTION_UPDATE_CARD_AT_INDEX: {
      const shipmentData = [ ...state.shipmentData ];
      const { index = 0, cardData } = action.data;

      shipmentData[index] = cardData;

      return {
        ...state,
        shipmentData,
        updateTaskSummary: !state.updateTaskSummary,
      }
    }

    case SHIPMENT_EXECUTION_SET_SELECTED_SHIPMENTS: {
      return {
        ...state,
        selectedShipments: action.data,
      }
    }

    default: {
      return state;
    }
  }
}
